<header-bar [pageTitle]="title" headingClass="fa-group"></header-bar>

<form [formGroup]="securityGroupForm" (ngSubmit)="saveSecurityGroup(securityGroupForm.value, securityGroupForm.valid)" novalidate>
    <div class="container mt-5 pb-5 mb-5">
        <div class="row mb-5">
            <div class="col">
                <div class="card mb-5">
                    <div class="card-header text-white bg-primary">
                        <div class="row align-items-center">
                            <p class="h3 m-0 col">Security group details</p>
                            <div class="col text-right">
                                <button type="submit" class="btn btn-outline-light btn-sm u-marginBottom--medium" [disabled]="!securityGroupForm.valid">
                                    Save changes
                                    <i class="fa fa-check ml-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="form-group" [ngClass]="{ 'has-error': !securityGroupForm.controls['name'].valid && securityGroupForm.controls['name'].touched }">
                                    <label for="name">Name *</label>
                                    <p class="form-text">Provide a name to help identify this group.</p>
                                    <input type="text" id="name" formControlName="name" class="form-control"/>
                                    <div *ngIf="securityGroupForm.controls['name'].hasError('required') && securityGroupForm.controls['name'].touched" class="alert alert-danger">You must include a name.</div>
                                </div>

                                <div class="form-group">
                                    <label for="deleted">Disable</label>
                                    <p class="form-text d-flex align-items-center">
                                        <input type="checkbox" id="disabled" name="disabled" formControlName="disabled" class="mr-2 d-inline-block"/> 
                                        Disable this group
                                    </p>
                                </div>
                            </div>
                            
                            <div class="col-md-8">
                                <div class="mr-3 mb-2" formArrayName="users">
                                    <div *ngFor="let sec of getUsersFormArray().controls; let i=index" class="mb-2 d-flex justify-content-between" [formGroupName]="i">
                                        <small>
                                            <i class="fa fa-user mr-2"></i> <strong>{{getUsersFormArray().controls[i].get('name')?.value}}</strong> ({{getUsersFormArray().controls[i].get('email')?.value}})
                                        </small>
                                        <i (click)="removeUser(i)" class="fa fa-close ml-1 text-info" role="button" title="Remove user"></i>
                                    </div>

                                    <div *ngIf="getUsersFormArray().controls == null || getUsersFormArray().controls.length < 1">
                                        <small><em class="text-muted">No users configured for this security group</em></small>
                                    </div>
                                </div>
                                <div class="btn btn-sm btn-primary mt-1" (click)="usersearchmodal.openModal()" title="Add users">
                                    Add users <i class="fa fa-plus ml-2"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
<confirmationmodal #confirmModal (onAccept)="onAccept();" (onDecline)="onDecline();"></confirmationmodal>
<usersearchmodal #usersearchmodal [(existingUserList)]="securityGroup.users" [containerName]="securityGroupForm.controls['name'].value" (selectedUsers)="usersSelected($event);" [includeGroups]="false"></usersearchmodal>